import React from 'react';

const Loading = () => {
  return <div />;
};

export default Loading;
